import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@app/core';
import { CertificateDataAdditionalFields } from '@app/page-modules/course-certificate-module/course-certificate-module.component';

import { UntilDestroy } from '@ngneat/until-destroy';
import * as moment from 'moment';

@UntilDestroy()
@Component({
  selector: 'certificate-fields-dialog',
  templateUrl: 'certificate-fields-dialog.component.html',
})
export class CertificateFieldsDialogComponent
  extends BaseComponent
  implements OnInit
{
  public fields!: CertificateDataAdditionalFields[];
  public form!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CertificateFieldsDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
  ) {
    super();

    if (data && data.additional_fields) {
      this.fields = data.additional_fields;
      this.form = this.createForm(this.fields);
    }
  }

  ngOnInit(): void {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(respData?: any): void {
    this.dialogRef.close(respData);
  }

  createForm(fields: CertificateDataAdditionalFields[]): FormGroup {
    const formFields = fields;

    const form = this._fb.group({});
    formFields.forEach((field) => {
      form.addControl(
        field.field_key,
        new FormControl(
          field.field_type == 'checkbox'
            ? false
            : field.field_type == 'number'
              ? 0
              : '',
        ),
      );

      // form.get(field.field_key)?.patchValue(field.field_value);

      if (field.is_required) {
        switch (field.field_type) {
          case 'checkbox':
            form.get(field.field_key)?.setValidators([Validators.requiredTrue]);
            break;
          case 'number':
            form
              .get(field.field_key)
              ?.setValidators([Validators.required, Validators.min(1)]);
            break;
          default:
            form.get(field.field_key)?.setValidators([Validators.required]);
            break;
        }
      }

      if (field.is_disabled) {
        form.get(field.field_key)?.disable();
      }
    });

    return form;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dateFormat(e: any, field: CertificateDataAdditionalFields) {
    let value = e.target.value;
    value = moment(value, 'DD.MM.YYYY', true).toDate();

    let dateValue = value;
    if (!moment.isMoment(dateValue)) {
      dateValue = moment(dateValue);
    }
    dateValue = dateValue.startOf('day');

    let formatedValue = dateValue;
    const dateFormat = 'YYYY-MM-DDTHH:mm:ss.sss[Z]';
    if (dateFormat) {
      formatedValue = dateValue.format(dateFormat);
    }

    this.form.get(field.field_key)?.patchValue(formatedValue);
  }

  save() {
    if (!this.fields) {
      return;
    }

    this.form.markAllAsTouched();
    this.form.markAsDirty();
    this.form.markAsTouched();
    this.form.updateValueAndValidity();

    if (!this.form.invalid) {
      this.close(this.form.value);
    }
  }
}
